import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "../css/Footer.css";
import SQSImg from "../images/SQS.svg";
import SCertImg from "../images/S-Cert.svg";
import SQS_Logo_50001 from "../images/SQS_Logo_50001.svg";
// import Facebook from "../svg/Facebook_blanc.svg";
// import Linkedin from "../svg/Linkedin_blanc.svg";
// import Instagram from "../svg/instagram_blanc.svg";
// import FacebookYellow from "../svg/Facebook_jaune.svg";
// import LinkedinYellow from "../svg/Linkedin_jaune.svg";
// import InstagramYellow from "../svg/instagram_jaune.svg";

/**
 * Footer component
 */
class Footer extends React.Component {
  static displayName = "Footer";
  static propTypes = {
    className: PropTypes.string,
    stores: PropTypes.object,
  };

  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "Footer";
  }

  /**
   * @override
   */
  render() {
    const FacebookURL = this.props.stores.page.FacebookURL;
    const InstagramURL = this.props.stores.page.InstagramURL;
    const LinkedinURL = this.props.stores.page.LinkedinURL;
    return (
      <div className={`${this.className} ${this.props.className || ""}`}>
        <div className={`${this.className}__wrapper`}>
          <div className={`${this.className}__logos`}>
            <img src={SQSImg} alt="SQS" />
            <img src={SQS_Logo_50001} alt="SQS_50001" />
            <img src={SCertImg} alt="SCert" />
          </div>
          <div className={`${this.className}__socials`}>
            <a
              href={LinkedinURL}
              rel="noopener noreferrer"
              target="_blank"
              className={`${this.className}__social linkedin`}
            />
            <a
              href={FacebookURL}
              rel="noopener noreferrer"
              target="_blank"
              className={`${this.className}__social facebook`}
            />
            <a
              href={InstagramURL}
              rel="noopener noreferrer"
              target="_blank"
              className={`${this.className}__social instagram`}
            />
          </div>
          <div className={`${this.className}__links`}>
            <Link className={`${this.className}__link`} to="/mentions-legales/">
              Mentions légales
            </Link>
            <Link className={`${this.className}__link`} to="/jobs/">
              Emploi
            </Link>
            <Link className={`${this.className}__link`} to="/contact-us/">
              Contact
            </Link>
          </div>
          <a
            className={`${this.className}__andeers`}
            href="http://www.andeers.ch"
            rel="noopener noreferrer"
            target="_blank"
          >
            Design by Andeers
          </a>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js